import React, { forwardRef, useState, useImperativeHandle, useRef } from "react";
import { Box, Stack, Typography, IconButton, Divider } from "@mui/material";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { Input } from "../Input";

const Pets = forwardRef((props, ref) => {
    const [pets, setPets] = useState(
        props.values ? props.values : [{ type: "", breed: "", weight: null, serviceAnimal: "" }]
    );

    const typeNameRef = useRef();
    const breedNameRef = useRef();
    const weightRef = useRef();
    const serviceAnimalRef = useRef();
    const refs = [typeNameRef, breedNameRef, weightRef, serviceAnimalRef];

    const serviceAnimalOptions = [
        {
            id: "Yes",
            value: "Yes",
        },
        {
            id: "No",
            value: "No",
        },
    ];

    const petTypeOptions = [
        {
            id: "Dog",
            value: "Dog",
        },
        {
            id: "Cat",
            value: "Cat",
        },
    ];

    useImperativeHandle(ref, () => ({
        validate,
    }));

    const validate = () => {
        let valid = false;
        for (let i = 0; i < refs.length; i++) {
            if (!refs[i].current.validate()) {
                valid = true;
            }
        }
        return !valid;
    };

    const handleAddClick = () => {
        let petsRecords = [...pets, { type: "", breed: "", weight: null, serviceAnimal: "" }];
        setPets(petsRecords);
    };

    const handleRemoveClick = (index) => {
        let petsRecords = [...pets];
        if (petsRecords.length > 1) {
            petsRecords.splice(index, 1);
            setPets(petsRecords);
            props.onChange(petsRecords);
        }
    };

    const handleChange = (index, field, value) => {
        let petsRecords = [...pets];
        petsRecords[index][field] = value;
        setPets(petsRecords);

        props.onChange(petsRecords);
    };
    return (
        <Box>
            {pets.map((item, index) => (
                <Box
                    sx={{
                        p: 1,
                        borderRadius: "8px",
                        border: "1px solid #E6E8F0",
                        overflow: "visible",
                        background: "#f8fdff",
                        width: "100%",
                        mb: 2,
                    }}
                >
                    <Grid container spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                        <Grid item>
                            <Typography gutterBottom variant="h5">
                                <b>Pet {index === 0 ? "" : index + 1}</b>
                            </Typography>
                        </Grid>
                        {(index > 1 || pets.length > 1) && (
                            <Grid item>
                                <IconButton aria-label="delete" size="small" style={{ float: "right" }}>
                                    <DeleteOutlinedIcon
                                        color="error"
                                        fontSize="small"
                                        onClick={() => handleRemoveClick(index)}
                                    />
                                </IconButton>
                            </Grid>
                        )}
                    </Grid>

                    <Divider sx={{ mt: 1, mb: 1 }} />

                    <Input
                        ref={typeNameRef}
                        id="type"
                        type="select"
                        options={petTypeOptions}
                        value={item.type}
                        margin="normal"
                        label="Type of pet"
                        onChange={(value) => handleChange(index, "type", value)}
                        isRequired={true}
                    ></Input>

                    <Input
                        ref={breedNameRef}
                        id="breed"
                        type="text"
                        label="Breed"
                        value={item.breed}
                        margin="normal"
                        onChange={(value) => handleChange(index, "breed", value)}
                        isRequired={true}
                    ></Input>

                    <Input
                        ref={weightRef}
                        id="weight"
                        type="number"
                        label="Weight (in lbs)"
                        value={item.weight}
                        margin="normal"
                        onChange={(value) => handleChange(index, "weight", value)}
                        isRequired={true}
                    ></Input>

                    <Input
                        ref={serviceAnimalRef}
                        id="serviceAnimal"
                        type="select"
                        options={serviceAnimalOptions}
                        label="Is this a service animal?"
                        value={item.serviceAnimal}
                        margin="normal"
                        onChange={(value) => handleChange(index, "serviceAnimal", value)}
                        isRequired={true}
                    ></Input>
                </Box>
            ))}
            <Stack direction="row" spacing={2} sx={{ mt: 1, mb: 1 }} onClick={handleAddClick}>
                <AddCircleOutlineOutlinedIcon color="primary" />
                <Typography
                    variant="h6"
                    display="block"
                    gutterBottom
                    sx={{
                        textTransform: "none",
                        display: "flex",
                        alignItems: "center",
                        color: "#06aed4",
                        "&:hover": {
                            cursor: "pointer",
                        },
                    }}
                >
                    <b>Add another pet</b>
                </Typography>
            </Stack>
        </Box>
    );
});

export { Pets };
